import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";

export const style: any = {
    theme: {
        ball: {
          height: '8px',
          width: '8px',
          backgroundColor: BrandTokens.BrandColorPrimaryPure,
          borderRadius: GlobalTokens.BorderRadiusCircular,
          marginRight: GlobalTokens.SpacingSizeNano
        },
        label: {
          fontFamily: BrandTokens.FontFamily,
          fontSize: GlobalTokens.FontSizeXxs,
          fontWeight: BrandTokens.FontWeightMedium,
          color: BrandTokens.BrandColorPrimaryPure,
          lineHeight: GlobalTokens.LineHeightDefault,
          marginTop: GlobalTokens.SpacingSizeXxxs
        }
      }
}